// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FXIX","buttons":"styles_buttons__rA4ww"};